import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_HOSPITALS_LIST_QUERY_KEY } from "../types/CommonTypes";
import { HOSPITALS_LIST_RESPONSE } from "../types/ResponseTypes";

async function getHospitalsList(
  tenantId?: string
): Promise<HOSPITALS_LIST_RESPONSE> {
  const { data } = await fetcher({
    url: "/hospitals",
    headers: {
      "x-tenant-id": tenantId,
    },
  });
  return data;
}

function useGetHospitalsListQuery(tenantId?: string) {
  return useQuery({
    queryKey: [GET_HOSPITALS_LIST_QUERY_KEY, tenantId],
    queryFn: () => getHospitalsList(tenantId),
    enabled: !!tenantId,
  });
}

export default useGetHospitalsListQuery;
